import NS from 'src/ns';
import $ from 'jquery';
import assign from 'lodash/assign';

const smoothScroll = {
  $header: $('.stl-Header'),
  setting: {
    easing: 'linear',
    duration: 800
  },
  ignore: [
    '.stl-Drawer'
  ],
  $scroll: $('body,html'),
  observe: function(selector, setting) {
    let targetSelector = selector ? selector: 'a[href^="#"]';

    if (setting) {
      this.setSetting(setting);
    }

    $(document).on('click', targetSelector, this.onClick.bind(this));
  },
  onClick: function(e) {
    let $button = $(e.currentTarget);
    let $ignore = $button.closest(this.ignore.join(','));

    e.preventDefault();

    if (!$ignore.length) {
      this.scroll($button);
    }
  },
  scroll: function($button) {
    let position = this.getPosition($button);

    if (position !== null) {
      this.$scroll.animate({ scrollTop: position }, this.setting.duration, this.setting.easing);
    }
  },
  getPosition: function($button) {
    let targetSelector = $button.attr('href') || '#' + $button.attr('aria-labelledby');
    let $target = $(targetSelector === '#' || targetSelector === '' ? 'html' : targetSelector);
    let $header = this.$header;
    let position = null;
    let isHeaderFixed = $header.css('position').toLowerCase() === 'fixed';

    try {
      position = $target.offset().top;
    } catch (e) {}

    if (position === null) {
      return position;
    }

    if (isHeaderFixed) {
      position -= $header[0].getBoundingClientRect().height;
    }

    if (position < 0) {
      position = 0;
    }

    return position;
  },
  setSetting: function(setting) {
    this.setting = assign(this.setting, setting);
  },
  forceTop: function() {
    window.scrollTo(0, 0);
  },
  forceScroll: function(x, y) {
    window.scrollTo(x, y);
  }
};

export default NS.smoothScroll = smoothScroll;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/utility/smoothScroll.js